<template>
  <div class="saved-query-list">
    <h3>Saved Queries:</h3>
    <ul class="query-list">
      <li v-for="(item, index) in savedQueries" :key="index" class="query-item">
        <div class="query-header">
          <span class="query-date">{{ item.date }}</span>
          <div class="query-actions">
            <button class="btn-edit" @click="$emit('edit-query', index)">Edit</button>
            <button class="btn-delete" @click="$emit('delete-query', index)">Delete</button>
          </div>
        </div>
        <div class="query-content">
          <span v-if="item.preset === 'search'">Search: {{ item.searchItem }}</span>
          <span v-else-if="item.preset === 'report'">Report on: {{ item.subject }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    savedQueries: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.saved-query-list {
  background-color: #1c1e24;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  color: #ffffff;
}

h3 {
  color: #00d1b2;
  font-family: 'Orbitron', sans-serif;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 20px;
}

.query-list {
  list-style-type: none;
  padding: 0;
}

.query-item {
  background: linear-gradient(135deg, #2a2d34 0%, #24272e 100%);
  border: 1px solid #3a3f4b;
  border-radius: 8px;
  margin-bottom: 15px;
  padding: 15px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.query-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.5);
}

.query-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.query-date {
  color: #ff6f61;
  font-weight: bold;
  font-size: 1.1em;
  font-family: 'Orbitron', sans-serif;
}

.query-actions {
  display: flex;
  gap: 10px;
}

.btn-edit, .btn-delete {
  background-color: #00d1b2;
  border: none;
  border-radius: 4px;
  color: #1c1e24;
  cursor: pointer;
  font-weight: bold;
  padding: 5px 10px;
  transition: background-color 0.3s ease;
}

.btn-delete {
  background-color: #dc3545;
}

.btn-edit:hover {
  background-color: #00bfa5;
}

.btn-delete:hover {
  background-color: #c82333;
}

.query-content {
  font-family: 'Courier New', monospace;
}
</style>
